import MapHelper from "./helper";

const SingleSearch = (value) => {
  return fetch(
    `https://singlesearch.alk.com/WW/api/search?authToken=${MapHelper.getKey()}&query=${value}&maxResults=5&countries=${MapHelper.getCountry()}`
  )
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((error) => {
      return null;
    });
};
export default SingleSearch;
